import { render } from "./xtx-numbox.vue?vue&type=template&id=73482e50&scoped=true"
import script from "./xtx-numbox.vue?vue&type=script&lang=js"
export * from "./xtx-numbox.vue?vue&type=script&lang=js"

import "./xtx-numbox.vue?vue&type=style&index=0&id=73482e50&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73482e50"]])

export default __exports__